// google-maps-loader.service.ts
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class GoogleMapsLoaderService {
    private apiKey = "AIzaSyDWRpriUobnctUbPqHBRgVmCdcaRrrdvCA";
    private scriptLoadingPromise: Promise<void> | null = null;

    load(): Promise<void> {
        if (this.scriptLoadingPromise) return this.scriptLoadingPromise;

        if ((window as any)["google"]?.maps) {
            return Promise.resolve(); // already loaded
        }

        this.scriptLoadingPromise = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = (err) => reject(err);
            document.head.appendChild(script);
        });

        return this.scriptLoadingPromise;
    }
}
